import { render, staticRenderFns } from "./Follower.vue?vue&type=template&id=3e57518e&scoped=true&"
import script from "./Follower.vue?vue&type=script&lang=js&"
export * from "./Follower.vue?vue&type=script&lang=js&"
import style0 from "./Follower.vue?vue&type=style&index=0&id=3e57518e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e57518e",
  null
  
)

export default component.exports